import createAxios from 'config/axios'

export const getAccount = () => createAxios.get('registrar/v1/customers/accounts')//eslint-disable-line

